import {Button, DialogActions, DialogContent} from "@mui/material";
import CommonModal from "./CommonModal";
import {LoadingButton} from "@mui/lab";
import Loading from "../Loading";

export default function CommonDeleteModal(props) {

    const removeEnvironment = async () => {
        let response = await props.removeEnvironment(props.currentEnvName);
        if(!response.hasOwnProperty('error')) {
            props.close()

        }
    }

    const getContent = () => {
        return (
            <>
                <DialogContent>
                    <Loading
                        isLoading={props.response.isLoading}
                        isError={props.response.isError}
                        error={props.response.error}
                    ></Loading>
                </DialogContent>
                <DialogActions>
                    <Button variant={"outlined"} onClick={props.close}>
                        Cancel
                    </Button>
                    <LoadingButton loading={props.response.isLoading || false} variant={"contained"} onClick={removeEnvironment}>
                        YES
                    </LoadingButton>
                </DialogActions>
            </>
        )
    }

    return (
        <CommonModal
            open={props.open}
            handleDialogClose={props.close}
            title={props.title}
            content={getContent()}
        />
    )
}